export enum ProductTypesEnum {
  all = 0,
  purchase = 1,
  sale = 2,
  recipe = 3,
  elaboration = 4,
}
